import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { SiteService } from 'app/_services/site.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'worker-schedule-site-list',
  templateUrl: './worker-schedule-site-list.component.html',
})
export class WorkerScheduleSiteListComponent implements OnInit {
  public sites: any[];
  private role: any;
  private routeRole: any;
  public pageSizes: any = environment.pageSizes;
  public pagination: any;

  constructor(
    private siteService: SiteService,
    private router: Router,
    private globals: Globals,
  ) {
    this.role = globals.user.role;
    this.routeRole = globals.user.routeRole;
    this.resetPagination();
  }

  ngOnInit() {
    this.getAllSites(this.pagination);
  }

  public getAllSites(pagination) {
    this.siteService.getAllSitesForWorker(pagination, true).subscribe((data: any) => {
      this.sites = data.body;
      this.pagination.totalRecords = Number(data.headers.get('X-Total-Count'));
    });
  }

  public onRowSelect(event) {
    this.router.navigate(['/' + this.routeRole + '/scheduling/sites', event.data.site.id]);
  }

  public paginate(event) {
    this.pagination.size = event.rows;
    this.pagination.page = event.page;
    this.getAllSites(this.pagination);
  }

  public resetPagination() {
    this.pagination = {
      size: this.pageSizes[0],
      page: 0,
      totalRecords: 0
    }
  }
}
